var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import style from './CAFleet-hashed.scss';
import LocaleUtil from 'gw-portals-util-js/LocaleUtil';

function getSortingStyle(attribute, sortingProperty, numeric, descending) {
    var icon = null;
    var type = 'sortIndicator-icon';

    if (!sortingProperty || sortingProperty !== attribute) {
        // no sorting applied or sorting property is different than considered attribute/column
        // need to provide 'neutral' icon
        icon = 'fa-exchange fa-rotate-90';
        type += '_inactive';
    } else {
        // sorting applies to the considered attribute
        // need to provide proper icon depending on the direction
        icon = 'fa-sort-' + (numeric ? 'amount' : 'alpha') + '-' + (descending ? 'desc' : 'asc');
        type += '_active';
    }
    return 'fa ' + icon + ' ' + style[type];
}

var CAFleetCtrl = function () {
    function CAFleetCtrl($scope, $filter, $translate, claimViewModel, PolicyService, TranslateService, LocaleService, AddressUtil, fleetPageSize) {
        var _this = this;

        _classCallCheck(this, CAFleetCtrl);

        this.updateFilterState = function (queriedData, filterApplicable, query) {
            _this.updateVehiclesList(queriedData);
            _this.filterApplicable = filterApplicable;
            _this.query = query;
        };

        this.sortProperties = function (attribute, descending) {
            if (attribute === 'year') {
                _this.allVehicles = _this.allVehicles.slice().sort(function (a, b) {
                    var aYear = a.year;
                    var bYear = b.year;
                    return descending ? bYear - aYear : aYear - bYear;
                });
                return;
            }
            _this.allVehicles = LocaleUtil.sortProperties(_this.allVehicles, _this.LocaleService.getCurrentLocale(), attribute, descending);
        };
        this.getSortingStyle = getSortingStyle;
        this.keepDropdownOpen = function (event) {
            event.stopPropagation();
        };

        this.pageSize = fleetPageSize;
        this.claimVm = claimViewModel();
        this.reset = false;
        this.loading = true;
        this.errorMsg = null;
        this.filterApplicable = null;
        this.query = null;
        this.$filter = $filter;
        this.PolicyService = PolicyService;
        this.TranslateService = TranslateService;
        this.LocaleService = LocaleService;
        this.$scope = $scope;
        this.$translate = $translate;

        this.allVehicles = null;
        this.vehicles = null;
        this.filteredVehicles = null;
        this.selectedVehicles = null;
        this.sharedPageNum = null;

        this.inUpdateState = false;

        this.availableModels = [];
        this.selectedModel = null;
        this.selectedModelIndex = 0;

        if (!this.claimVm.policy.lobs.commercialAuto) {
            this.claimVm.policy.lobs.value = { commercialAuto: { vehicles: [] } };
        }

        this.policyVehicles = this.claimVm.policy.lobs.commercialAuto.vehicles.value;
        this.translateMessages();
        this.initVehicles();

        $scope.$watchGroup([function () {
            return _this.selectedModel;
        }, function () {
            return _this.selectedModelIndex;
        }, function () {
            return _this.allVehicles;
        }], function () {
            var selected = _this.availableModels[_this.selectedModelIndex];
            _this.filteredAllVehicles = _this.selectedModelIndex === 0 ? _this.allVehicles : _this.allVehicles.filter(function (v) {
                return v.make === selected.make && v.model === selected.model;
            });
        });
    }

    _createClass(CAFleetCtrl, [{
        key: 'translateMessages',
        value: function translateMessages() {
            this.translation = {
                label: '',
                error: ''
            };

            this.TranslateService.translate({
                object: this.translation,
                displayKey: 'fnol.ca.views.ca-fleet.Vehicles',
                propName: 'label',
                scope: this.$scope
            });

            this.TranslateService.translate({
                object: this.translation,
                displayKey: 'fnol.ca.views.ca-fleet.No results found. Please try widening your search criteria.',
                propName: 'error',
                scope: this.$scope
            });
        }
    }, {
        key: 'initVehicles',
        value: function initVehicles() {
            var _this2 = this;

            this.loading = true;
            this.errorMsg = null;
            this.loader = this.PolicyService.getPolicySummaryRiskUnits(this.claimVm.policy.policyNumber.value, this.claimVm.lossDate.value).then(function (riskUnits) {
                _this2.loading = false;
                var allVehicles = riskUnits.lobs.commercialAuto.vehicles;
                _this2.vehicles = riskUnits.lobs.commercialAuto.vehicles;
                allVehicles.forEach(function (vehicle) {
                    vehicle.selected = _this2.policyVehicles.findIndex(function (unit) {
                        return unit.policySystemId === vehicle.policySystemId;
                    }) > -1;
                });
                _this2.allVehicles = allVehicles;
                _this2.updateSelectionSummary();
                _this2.$translate('fnol.ca.views.ca-fleet.All Models').then(function (allModels) {
                    return _this2.updateAvailableModels(allModels);
                });
            }, function (error) {
                _this2.errorMsg = _this2.translation.error + error;
            });
        }
    }, {
        key: 'vehiclesChanged',
        value: function vehiclesChanged() {
            var _this3 = this;

            this.vehicles.forEach(function (unit) {
                var index = _this3.policyVehicles.findIndex(function (policyUnit) {
                    return policyUnit.policySystemId === unit.policySystemId;
                });
                if (unit.selected && index < 0) {
                    _this3.policyVehicles.push(unit);
                } else if (!unit.selected && index >= 0) {
                    _this3.policyVehicles.splice(index, 1);
                }
            });
        }
    }, {
        key: 'updateAvailableModels',
        value: function updateAvailableModels(allModels) {
            var models = new Map();
            this.allVehicles.forEach(function (vehicle) {
                return models.set(vehicle.make + ' ' + vehicle.model, {
                    frontendKey: vehicle.make + ' ' + vehicle.model,
                    make: vehicle.make,
                    model: vehicle.model
                });
            });

            var modelsArr = LocaleUtil.sortProperties(Array.from(models.values()), this.LocaleService.getCurrentLocale(), 'frontendKey', false);
            this.availableModels = [{
                frontendKey: allModels
            }].concat(modelsArr);
        }
    }, {
        key: 'updateSelectionSummary',
        value: function updateSelectionSummary() {
            var _this4 = this;

            this.selectedVehicles = this.allVehicles.filter(function (ru) {
                return _this4.policyVehicles.findIndex(function (policyUnit) {
                    return policyUnit.policySystemId === ru.policySystemId;
                }) !== -1;
            });
        }
    }, {
        key: 'updateVehiclesList',
        value: function updateVehiclesList(vehicles) {
            this.vehicles = vehicles;
            this.reset = !this.reset;
            this.inUpdateState = true;
        }
    }, {
        key: 'onPaginationNavigation',
        value: function onPaginationNavigation(vehicles, pageNum) {
            if (this.inUpdateState || pageNum !== this.sharedPageNum) {
                this.filteredVehicles = vehicles.items;
                this.sharedPageNum = pageNum;
                this.inUpdateState = false;
            }
        }
    }, {
        key: 'toggleVehicleSelection',
        value: function toggleVehicleSelection(vehicle) {
            vehicle.selected = !vehicle.selected;
            this.vehiclesChanged();
            this.updateSelectionSummary();
        }
    }, {
        key: 'formatCellContent',
        value: function formatCellContent(content) {
            return this.filterApplicable ? this.$filter('highlightPhrase')(content || '', this.query, 'bold') : content;
        }
    }, {
        key: 'setModelIndex',
        value: function setModelIndex(option, index) {
            this.selectedModel = option;
            this.selectedModelIndex = index;
        }
    }, {
        key: 'numSelectedVehicles',
        value: function numSelectedVehicles() {
            return this.selectedVehicles && this.selectedVehicles.length ? this.selectedVehicles.length : 0;
        }
    }, {
        key: 'next',
        value: function next(nextFn) {
            nextFn(this.claimVm);
        }
    }]);

    return CAFleetCtrl;
}();

CAFleetCtrl.$inject = ['$scope', '$filter', '$translate', 'claimViewModel', 'fnol.PolicyService', 'TranslateService', 'LocaleService', 'AddressUtil', 'fleetPageSize'];

export default CAFleetCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/ca/CAFleet/CAFleetCtrl.js
// module id = 1486
// module chunks = 0